// 되묻기 카드 — 에이전트가 ask_user 로 물으면 여기서 답한다. 답은 한 번만 보낸다.
// 서버(askUserBroker)가 실제 1회성을 보장하고, 화면은 답한 뒤 선택 흔적을 남긴다.
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FiHelpCircle } from 'react-icons/fi';
import styles from './AssistantPanel.module.css';

function QuestionCard({ question, resolved, onAnswer }) {
    const { t } = useTranslation();
    const [free, setFree] = useState('');
    const [picked, setPicked] = useState([]);
    const done = !!resolved;
    const options = question.options || [];
    const multi = !!question.multiSelect;

    const submitOption = (label) => {
        if (done) return;
        if (!multi) { onAnswer(question.questionId, label); return; }
        setPicked(prev => (prev.includes(label) ? prev.filter(x => x !== label) : [...prev, label]));
    };
    const submitFree = () => {
        const v = free.trim();
        if (!v || done) return;
        onAnswer(question.questionId, v);
        setFree('');
    };
    const submitMulti = () => {
        if (picked.length === 0 || done) return;
        onAnswer(question.questionId, picked);
    };

    const answerText = resolved
        ? (Array.isArray(resolved.answer) ? resolved.answer.join(', ') : String(resolved.answer ?? ''))
        : '';

    return (
        <div className={styles.question}>
            <div className={styles.questionHead}>
                <FiHelpCircle size={12} /> {question.header || t('assistant:question.title')}
            </div>
            <div className={styles.questionText}>{question.question}</div>

            {options.length > 0 && (
                <div className={styles.options}>
                    {options.map((o) => (
                        <button
                            key={o.label}
                            type="button"
                            className={`${styles.optionBtn} ${picked.includes(o.label) || (done && answerText === o.label) ? styles.optionPicked : ''}`}
                            disabled={done}
                            onClick={() => submitOption(o.label)}
                        >
                            {o.label}
                            {o.description ? <span className={styles.optionDesc}>{o.description}</span> : null}
                        </button>
                    ))}
                    {multi && !done && (
                        <button type="button" className={styles.smallBtn} onClick={submitMulti} disabled={picked.length === 0}>
                            {t('assistant:question.submit')}
                        </button>
                    )}
                </div>
            )}

            {question.allowFreeText !== false && !done && (
                <div className={styles.freeRow}>
                    <input
                        className={styles.freeInput}
                        value={free}
                        placeholder={t('assistant:question.freeTextPlaceholder')}
                        onChange={(e) => setFree(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); submitFree(); } }}
                    />
                    <button type="button" className={styles.smallBtn} onClick={submitFree} disabled={!free.trim()}>
                        {t('assistant:question.submit')}
                    </button>
                </div>
            )}

            {done && (
                <div className={styles.resolved}>
                    {resolved.source === 'timeout'
                        ? t('assistant:question.timedOut')
                        : <>{t('assistant:question.answered')}: <strong>{answerText}</strong></>}
                </div>
            )}
        </div>
    );
}

QuestionCard.propTypes = {
    question: PropTypes.object.isRequired,
    resolved: PropTypes.object,
    onAnswer: PropTypes.func.isRequired,
};

export default QuestionCard;
